module.exports = __webpack_public_path__ + "img/accessoire-manitou-1.f1f3dba8.png";